import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { SolicitudEnvioExViewModel } from '../../../../_exportacion/solicitudes/envio/envioEx.types';
import { CertificadosFsItemViewModel, CertificadosFsViewModel } from '../buscador-certificadosfs.types';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { CertificadosFsService } from '../buscador-certificadosfs.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';

@Component({
    selector: 'app-certificadosfs-wrapper-edit',
    templateUrl: './buscador-certificadosfs-wrapper-edit.component.html',
    styleUrls: ['./buscador-certificadosfs-wrapper-edit.component.scss'],
})
export class CertificadosFsWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    certFs: CertificadosFsViewModel;
    formGroup: FormGroup;
    solicitud: SolicitudEnvioExViewModel;
    cert: CertificadosFsItemViewModel;

    successMessage = 'Solicitud guardada correctamente';
    listUrl = '/exportacion/certificadosfs';

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private certificadoService: CertificadosFsService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.certFs = new CertificadosFsViewModel();
    }

    ngOnInit(): void {
        this.certFs.IdSolicitud = this.activatedRoute.snapshot.params['idSolicitud'];
        this.certificadoService.getCertificado(this.certFs.IdSolicitud).subscribe(resultIsGrabada => {
            this.cert = resultIsGrabada;

            this.certFs.CodigoSolicitud = this.cert.Codigo;
            this.certFs.NumeroCertificado = this.cert.NumeroCertificado;
            this.certFs.EstadoCfDescripcion = this.cert.EstadoCfDescripcion;
            this.certFs.EstadoSolicitudExDescripcion = this.cert.EstadoSolicitudExDescripcion;
            this.certificadoService.getSolicitud(this.certFs.IdSolicitud).subscribe(result => {
                this.solicitud = result;
                this.certFs.CfDisponible = this.solicitud.CfDisponible;
                this.certFs.CfUtilizado = this.solicitud.CfUtilizado;
                this.preparePresentation();
            });
        });
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            NumeroCertificado: this.certFs.NumeroCertificado,
            EstadoCfDescripcion: this.certFs.EstadoCfDescripcion,
            CodigoSolicitud: this.certFs.CodigoSolicitud,
            EstadoSolicitudExDescripcion: this.certFs.EstadoSolicitudExDescripcion,
            CfUtilizado: this.certFs.CfUtilizado,
            CfDisponible: this.certFs.CfDisponible,
        });

        this.clearCustomValidator();

        this.form = this.formGroup;
    }

    private clearCustomValidator(): void {
        this.formGroup.valueChanges.subscribe(() => {
            try {
                this.removeCustomError('registry_duplicated', 'basic.CodigoSolicitud');
                this.formGroup.get('basic.CodigoSolicitud')?.updateValueAndValidity();
            } catch (e) {
                // Capturamos el error que se produce cuando carga el componente por primera vez, y el input todavía no tiene el CustomError
            }
        });
    }

    onSave() {
        this.submitted = true;
        this.visibilitySpinner = true;
        this.solicitud.CfDisponible = this.form.value.CfDisponible;
        this.solicitud.CfUtilizado = this.form.value.CfUtilizado;
        this.certificadoService.editSolicitud(this.solicitud).subscribe({
            next: () => {
                this.addSuccessMessage(this.successMessage);
                this.onBack();
                this.visibilitySpinner = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.formGroup?.valid || !this.formGroup?.dirty || this.formGroup?.pristine || false;
    }
}
